type Size = {width: number; height: number};

type VideoSourceSize = Size & {
  label: string;
  sourceWidth: number;
  sourceHeight: number;
};

export function findUndersizedVideoSources({
  output,
  surface,
  media,
}: {
  output: Size;
  surface: Size;
  media: VideoSourceSize[];
}): string[] {
  if (surface.width <= 0 || surface.height <= 0) return [];
  const scaleX = output.width / surface.width;
  const scaleY = output.height / surface.height;

  return media.flatMap((source) => {
    if (source.sourceWidth <= 0 || source.sourceHeight <= 0) return [];
    const requiredWidth = Math.ceil(source.width * scaleX);
    const requiredHeight = Math.ceil(source.height * scaleY);
    if (source.sourceWidth >= requiredWidth && source.sourceHeight >= requiredHeight) return [];
    return [
      `${source.label} (${source.sourceWidth}×${source.sourceHeight}; needs at least ${requiredWidth}×${requiredHeight})`,
    ];
  });
}

export function getVideoExportSourceWarnings(container: Element, output: Size): string[] {
  const surface = container.closest(".template-render-surface");
  if (!surface) throw new Error("Video export container is outside a template render surface");
  const surfaceRect = surface.getBoundingClientRect();
  const nodes = Array.from(
    container.querySelectorAll(
      ".bg-transformer img[alt='background'], .bg-transformer video[alt='background'], .image-upload img, .image-upload video"
    )
  );
  let uploadIndex = 0;
  const media = nodes.map((node) => {
    const rect = node.getBoundingClientRect();
    const isVideo = node instanceof HTMLVideoElement;
    const isBackground = node.closest(".bg-transformer") !== null;
    if (!isBackground) uploadIndex++;
    return {
      label: isBackground ? "background" : `uploaded media ${uploadIndex}`,
      sourceWidth: isVideo ? node.videoWidth : (node as HTMLImageElement).naturalWidth,
      sourceHeight: isVideo ? node.videoHeight : (node as HTMLImageElement).naturalHeight,
      width: rect.width,
      height: rect.height,
    };
  });
  return findUndersizedVideoSources({
    output,
    surface: {width: surfaceRect.width, height: surfaceRect.height},
    media,
  });
}
